import { EeveeTrackerConfigMap, TiangongConfig } from './config';
import startETracker from '@fuxi/eevee-tracker-starter';

const { ETracker, sendEvent, switchPage, sendPV, sendLeave, mark, measure, sendApi } = startETracker(
  EeveeTrackerConfigMap?.[import.meta.env.VITE_PLATFORM] || TiangongConfig,
);

export { ETracker, switchPage, sendPV, sendLeave, sendEvent, mark, measure, sendApi };
